var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.$vuetify.theme.dark ? { background: 'rgb(18,18,18)'} : { background: 'rgb(238,238,238)'}),attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }